<ng-container
  *ngIf="{
    maxAllowableBalance: maxAllowableBalance$ | async,
    enabled: enabled$ | async,
    balanceIsNegative: balanceIsNegative$ | async,
  } as obs"
>
  <ng-container *ngIf="obs.enabled !== undefined">
    <div class="apply-bonus-form" [class.apply-bonus-form--disabled]="!obs.enabled">
      <div class="apply-bonus-form__header">
        <ng-container *ngIf="!obs.balanceIsNegative">
          <sd-switch
            [checked]="obs.enabled"
            [disabled]="obs.maxAllowableBalance === 0"
            (changed)="enabledChanged($event)"
          ></sd-switch>

          <span>списать</span>
        </ng-container>

        <sd-bonus-widget [amount]="obs.maxAllowableBalance"></sd-bonus-widget>
      </div>

      <p *ngIf="obs.balanceIsNegative" class="apply-bonus-form__negative-warning">
        баллы с отрицательным балансом не получится списать
      </p>

      <ng-container *ngIf="obs.enabled">
        <input [formControl]="formControl" type="number" class="apply-bonus-form__input" sdOnlyNumber="integer" />
      </ng-container>
    </div>
  </ng-container>
</ng-container>
